import { IRentingLight, BankName } from '../tools/api.service';

export class RentingLight {
  rentingID: number;
  companyID: number;
  socialReason:string;
  country:string;
  ctcID: number;
  rentingDuration: number;
  status: number;
  isChecked: number;
  sageCode: string;
  bank: BankName;
  invoiceCode: string;
  rentingDate: string;
  treatmentDate:string;
  companyUnisiteCode: string;
  ctcFirstname: string;
  ctcName: string;
  ctcPhone: string;
  ctcMail: string;
  ctcLanguage: string;
  nbProducts: number;
  renewal: number;
  cashPayement: number;
      
  public static parseToRentingLight(item: IRentingLight): RentingLight {
    let result = new RentingLight();
    result.rentingID = item.rentingID;
    result.companyID = item.companyID;
    result.socialReason = item.socialReason;
    result.country = item.country;
    result.ctcID = item.ctcID;
    result.rentingDuration = item.rentingDuration;
    result.status = item.status;
    result.isChecked = item.isChecked;
    result.sageCode = item.sageCode;
    result.bank = item.bank;
    result.invoiceCode = item.invoiceCode;
    result.rentingDate = item.rentingDate;
    result.treatmentDate = item.treatmentDate;
    result.companyUnisiteCode = item.companyUnisiteCode;
    result.ctcFirstname = item.ctcFirstname;
    result.ctcName = item.ctcName;
    result.ctcPhone = item.ctcPhone;
    result.ctcMail = item.ctcMail;
    result.ctcLanguage = item.ctcLanguage;
    result.nbProducts = item.nbProducts;
    result.renewal = item.renewal;
    result.cashPayement = item.cashPayement;
    return result;
  }
}
